import { Component, inject } from '@angular/core';
import { AuthService } from '@app/core/services/auth/auth.service';
import { CourtService } from '@shared/services/court.service';
import { faPencil } from '@fortawesome/free-solid-svg-icons';
import { ButtonComponent } from '@shared/components/button';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { OpenApplicationSelectModalDirective } from './directives';

@Component({
  selector: 'app-admin-header',
  imports: [
    ButtonComponent,
    FaIconComponent,
    OpenApplicationSelectModalDirective,
  ],
  templateUrl: './header.component.html',
})
export class AdminHeaderComponent {
  public authService = inject(AuthService);
  public courtService = inject(CourtService);

  protected readonly pencilIcon = faPencil;

  protected logout() {
    this.authService.logout();
  }
}
